export default "__VITE_ASSET__CUysqB$t__"